import React, { Component } from 'react';
import Header from './HeaderComponent';
import { Switch, Route, Redirect, withRouter} from 'react-router-dom';
import Home from './HomeComponent';
import Projects from './ProjectsComponent';
import About from './AboutComponent';
import Collaborate from './CollaborateComponent';


class Main extends Component {

    

    render() {
        return(
            <div>
                <Header />
                <Switch>
                    <Route path ='/home' component={() => <Home/>} />
                    <Route path='/about' component={() => <About/>}/>
                    <Route path='/projects' component={() => <Projects/>}/>
                    <Route path='/collaborate' component={() => <Collaborate/>}/>
                    {/* <Route path='/' component={() => <Home/>}/> */}
                    <Redirect to='/home'/>
                </Switch> 
            </div>
        );
    }
}

export default withRouter(Main);